import type { Option } from "@/shared/components/ui/autocomplete";
import { AutoComplete, Button, Icon } from "@/shared/components/ui";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

type StationRowProps = {
    id: string;
    stationCode: string;
    stationOptions: Option[];
    onChangeStation: (code: string) => void;
    onRemove: () => void;
    canRemove: boolean;
    hasError?: boolean;
};

export function StationRow({ id, stationCode, stationOptions, onChangeStation, onRemove, canRemove, hasError = false }: Readonly<StationRowProps>) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <div ref={setNodeRef} style={style} className="flex items-center gap-2">
            <button
                type="button"
                className="text-content-subtle hover:text-content-emphasis cursor-grab touch-none active:cursor-grabbing"
                {...attributes}
                {...listeners}
            >
                <Icon name="drag-indicator" size="m" />
            </button>
            <div className="flex-1">
                <AutoComplete
                    options={stationOptions}
                    value={stationCode}
                    onChange={onChangeStation}
                    placeholder="Zoek station..."
                    emptyMessage="Geen stations gevonden"
                    hasError={hasError}
                    showSearchIcon={false}
                />
            </div>
            <Button
                variant="tertiary"
                destructive
                size="s"
                icon="trash"
                onClick={onRemove}
                disabled={!canRemove}
                aria-label="Station verwijderen"
            />
        </div>
    );
}
